import http from "../index"
import {
  apiListOrder,
  apiDetailOrder,
  apiDeleteOrder,
  apiUpdateOrder,
  apiCreateOrder,
  apiListOrderM2M,
  apiDetailOrderM2M,
  apiDeleteOrderM2M,
  apiUpdateOrderM2M,
  apiCreateOrderM2M,
  apiBrowseOrderM2M,
  apiRefuseOrderM2M
} from "./urls"

const listOrders = params => http.get(apiListOrder, { params: params })
const createOrder = body => http.post(apiCreateOrder, body)
const updateOrder = (id, body) => http.put(apiUpdateOrder(id), body)
const deleteOrder = id => http.delete(apiDeleteOrder(id))
const detailOrder = id => http.get(apiDetailOrder(id))
const listOrderM2M = params => http.get(apiListOrderM2M, { params: params })
const createOrderM2M = body => http.post(apiCreateOrderM2M, body)
const updateOrderM2M = (id, body) => http.put(apiUpdateOrderM2M(id), body)
const deleteOrderM2M = id => http.delete(apiDeleteOrderM2M(id))
const detailOrderM2M = id => http.get(apiDetailOrderM2M(id))
const browseOrderM2M = id => http.put(apiBrowseOrderM2M(id))
const refuseOrderM2M = (id, body) => http.put(apiRefuseOrderM2M(id), body)

const OrderPoolDataService = {
  listOrders,
  createOrder,
  updateOrder,
  deleteOrder,
  detailOrder,
  listOrderM2M,
  createOrderM2M,
  updateOrderM2M,
  deleteOrderM2M,
  detailOrderM2M,
  browseOrderM2M,
  refuseOrderM2M
}
export default OrderPoolDataService
